import React, { useState, useEffect, useRef } from "react";
// import toast from 'react-hot-toast';
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import DataTable from "react-data-table-component";


//Redux
import { useDispatch } from "react-redux";

//API
import ItemService from "../../../../services/supplier_appCommonService";
import logistics from "../../../../services/logistics_appCommonService";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";




//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import Constants from "../../../../common/SupplierConstants";
import POCollabrationCommonFillter from "../../../../Components/Filter/POCollabration/POCollabrationCommonFillter";
import HeaderText from "../../../../Components/Modal/supplier_app/PO_Collabration/HeaderText";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
// import GoogleMapComponent from "../../Common/GoogleMapComponent";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import { useSelector } from "react-redux"; //useDispatch
import { useNavigate } from "react-router-dom";
import LogisticsConstants from "../../../../common/LogisticsConstants";
// import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import GoogleMapComponentFromTo from "../../Common/GoogleMapComponentFromTo";




const TransportRequestDetails = () => {
  const inputRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Transport Request");

  let transportID = useSelector((state) => state?.logistics?.transport?.transportNr)


  localStorage.setItem("menu", "Logistics");
  localStorage.setItem("submenu", "Transport Request");

  // User Details from Store

  const modalData = {
    title: "Trasnport Details",
    successMsg: "",
  };

  const [gettransportRequest, settransportRequest] = useState({
    transportrequestDetails: {
      transportRequestDate: "",
      department: "",
      transportGroup: "",
      purchaseOrderNr: "",
      licenseNr: "",
      issuingDate: "",
      expiryDate: "",
      driverName1: "",
      vehicleNr: "",
    }

  })

  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const [getModalInfo, /*setModalInfo*/] = useState(modalData);
  const [subTotalValue, setSubTotalValue] = useState(0);
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);

  const [otherCharges, setOtherCharges] = useState()

  const [getItemLevelData,/* setItemLevelData*/] = useState([]);
  const [getItemLevelColumns, /*setItemLevelColumns*/] = useState([]);
  const [getModalTitle, /*setModalTitle*/] = useState("");
  const [getViewHeaderText, setViewHeaderText] = useState(false);
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);
  // added new one for 

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible1, setCardVisible1] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible4, setCardVisible4] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);


  const [getGrossValue, setGrossValue] = useState(0);
  useEffect(() => {
    const subtotal = Number(subTotalValue) || 0;
    const otherCharges = Number(getOtherChargesValue) || 0;
    setGrossValue(subtotal + otherCharges);
  }, [subTotalValue, getOtherChargesValue]);


  const [invoiceData, setInvoiceData] = useState([]);
  const [getCustomer, /*setCustomer*/] = useState([]);
  const [getDropdownData, setDropdownData] = useState([]);

  let SchedulePOLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",


    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}

          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}

        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}

        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}

        />
      ),
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange1(row.local_id, event, "purchaseQuantity")}
          disabled={true}

        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange1(row.local_id, event, "orderPriceUnit")}
          disabled={true}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value",
      selector: (row) => row.itemValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="itemValue"
          placeholder=""
          value={row.itemValue || ""}
          disabled={true}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    // {
    //   name: "Delivery Date",
    //   selector: (row) => row.deliveryDate || "--",
    //   cell: (row) => (
    //     <InputField
    //       className="inputBox mt-1"
    //       type="date"
    //       name="deliveryDate"
    //       placeholder=""
    //       value={row.deliveryDate || ""}
    //       onChange={(event) => handleInputChange(row.local_id, event)}
    //       disabled={true}

    //     />
    //   ),
    //   width: "200px",
    // },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}

        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
          disabled={true}

        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
          disabled={true}

        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  let SchedulePOLineItemInitialCol1 = [
    {
      name: "Trip Id",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    // {
    //   name: "Item Text",
    //   selector: (row) => row.local_id || "--",
    //   sortable: true,
    //   width: "110px",
    //   cell: (row) => (
    //     <>
    //       <span style={{ marginLeft: "12px" }}>
    //         <i className="bi bi-calendar2-week iconTable"></i>
    //       </span>
    //       <span className="suppliersIcon">
    //         {" "}
    //         {row.itemTextData?.length || 0}{" "}
    //       </span>
    //     </>
    //   ),
    // },
    {
      name: "Trip Started Date ",
      selector: (row) => row.tripStartedDate1 || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          // label="Please Enter the Remarks*"
          name="tripStartedDate1"
          placeholder=""
          value={row.tripStartedDate1 || ""}
          // onChange={(event) => handleInputChange2(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "From Location",
      selector: (row) => row.fromLocation1 || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="fromLocation1"
          placeholder=""
          value={row.fromLocation1 || ""}
          // onChange={(event) => handleInputChange2(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "To Location ",
      selector: (row) => row.toLocation1 || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="toLocation1"
          placeholder=""
          value={row.toLocation1 || ""}
          // onChange={(event) => handleInputChange2(row.local_id, event)}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Trip KMS ",
      selector: (row) => row.tripKMS || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="tripKMS"
          placeholder=""
          value={row.tripKMS || ""}
          // onChange={(event) => handleInputChange2(row.local_id, event)}
          disabled={true}
        />
      ),
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];

  const HeaderTextColumns = [
    {
      name: "Code",
      cell: (row) => (
        <>
          <span>{row.documentId}</span>
        </>
      ),
      width: "30rem",
    },
    {
      name: "Value",
      cell: (row) => (
        <>
          <span>{row.documentText}</span>
        </>
      ),
      width: "30rem",
    },
  ];

  /* radio buttons */
  const [selectedShipment, setSelectedShipment] = useState();
  const [availableShipments, setAvailableShipments] = useState([]);

  useEffect(() => {
    if (availableShipments.length > 0) {
      setSelectedShipment(availableShipments[0]); // Set first available shipment mode
    }
  }, [availableShipments]);


  const [formInputs, setFormInputs] = useState({
    selectedTripType: "",
    pricingSummary: {
      subTotalValue: "",
      getOtherChargesValue: "",
      grossTotalValue: "",

    },
    transportrequestDetails: {
      transportRequestDate: "",
      department: "",
      transportGroup: "",
      purchaseOrderNr: "",
    },
    senderAddress: {
      customerDetails: "",

    },
    tripTypes: {
      oneWayTrip: "",
      twoWayTrip: "",


    }
  });


  const [getShipment, setShipment] = useState({});
  const [getupdateLogisticsTransport, setupdateLogisticsTransport] = useState();
  // useEffect(() => {
  //     if (gettransportRequest) {
  //       setupdateLogisticsTransport(prev => ({
  //         ...prev,
    
  //         // From transportrequestDetails
  //         transportRequestDate: gettransportRequest?.transportrequestDetails?.transportRequestDate,
  //         department: gettransportRequest?.transportrequestDetails?.department,
  //         transportGroup: gettransportRequest?.transportrequestDetails?.transportGroup,
  //         purchaseOrderNr: gettransportRequest?.transportrequestDetails?.purchaseOrderNr,
    
  //         // From senderAddress
  //         customerDetails: formInputs?.senderAddress?.customerDetails,
    
  //         // From pricingSummary
  //         subTotalValue: formInputs?.pricingSummary?.subTotalValue,
  //         getOtherChargesValue: formInputs?.pricingSummary?.getOtherChargesValue,
  //         grossTotalValue: formInputs?.pricingSummary?.grossTotalValue,
    
  //         // From oneWayTrip
  //         tripTypes: formInputs?.oneWayTrip?.tripTypes,
  //         tripstartDate: formInputs?.oneWayTrip?.tripstartDate,
  //         fromLocation: formInputs?.oneWayTrip?.fromLocation,
  //         toLocation: formInputs?.oneWayTrip?.toLocation,
    
  //         // From twoWayTrip
  //         tripstartDate2: formInputs?.twoWayTrip?.tripstartDate2,
  //         fromLocation2: formInputs?.twoWayTrip?.fromLocation2,
  //         toLocation2: formInputs?.twoWayTrip?.toLocation2,
  //       }));
  //     }
  //   }, [gettransportRequest]);
  useEffect(() => {
    if (gettransportRequest) {
      setupdateLogisticsTransport(prev => ({
        ...prev,
  
        // From transportrequestDetails
        transportRequestDate: gettransportRequest?.transportrequestDetails?.transportRequestDate,
        department: gettransportRequest?.transportrequestDetails?.department,
        transportGroup: gettransportRequest?.transportrequestDetails?.transportGroup,
        purchaseOrderNr: gettransportRequest?.transportrequestDetails?.purchaseOrderNr,
  
        // From senderAddress
        customerDetails: formInputs?.senderAddress?.customerDetails,
  
        // From pricingSummary
        subTotalValue: formInputs?.pricingSummary?.subTotalValue,
        getOtherChargesValue: formInputs?.pricingSummary?.getOtherChargesValue,
        grossTotalValue: formInputs?.pricingSummary?.grossTotalValue,
  
        // From oneWayTrip
        tripTypes: formInputs?.tripTypes?.oneWayTrip?.tripTypes,
        tripstartDate: formInputs?.tripTypes?.oneWayTrip?.tripstartDate,
        fromLocation: formInputs?.tripTypes?.oneWayTrip?.fromLocation,
        toLocation: formInputs?.tripTypes?.oneWayTrip?.toLocation,
  
        // From twoWayTrip
        tripstartDate2: formInputs?.tripTypes?.twoWayTrip?.tripstartDate2,
        fromLocation2: formInputs?.tripTypes?.twoWayTrip?.fromLocation2,
        toLocation2: formInputs?.tripTypes?.twoWayTrip?.toLocation2,
      }));
    }
  }, [gettransportRequest, formInputs]); // Make sure to include formInputs here if it's part of the data
  
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility1 = () => {
    setCardVisible1(!isCardVisible1);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility4 = () => {
    setCardVisible4(!isCardVisible4);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const [getCustomerDetails, setCustomerDetails] = useState(null);
  const [senderOthersCustomer, setSenderOthersCustomer] = useState(false); // default false
  const tripType = [
    { id: 1, name: "Round Trip", textField: "Select trip Type" },
    { id: 2, name: "One Way Trip", textField: "Select trip Type" },
    { id: 3, name: "Two Way Trip", textField: "Select trip Type" },

  ]

  const [getTripType, setTripType] = useState();
  const [getTripTypeData, setTripTypeData] = useState();
 

  const [getReciverCustomerDetails, setReciverCustomerDetails] = useState(null);
  const [reciverOthersCustomer, setReciverOthersCustomer] = useState(false);


  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
  };
  const transportrequestInputchange = ({ target: { name, value } }) => {
    settransportRequest((gettransportRequest) => ({ ...gettransportRequest, [name]: value }));
  };
  const pricingSummaryInputchange = ({ target: { name, value } }) => {
    setSubTotalValue((subTotalValue) => ({
      ...subTotalValue,
      [name]: value,
    }));
  };
  const TripTypeonInputChange = ({ target: { name, value } }) => {
    setTripType((getTripType) => ({ ...getTripType, [name]: value }));
  };
  const otherChargeInputchange = ({ target: { name, value } }) => {
    setOtherChargesValue((getOtherChargesValue) => ({
      ...getOtherChargesValue,
      [name]: value,
    }));
  };
  const GrossValueInputchange = ({ target: { name, value } }) => {
    setGrossValue((getGrossValue) => ({
      ...getGrossValue,
      [name]: value,
    }));
  };
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  /* Shipment details fields */
  const renderShipmentDetails = () => {
    switch (selectedShipment) {
      case "road":
        return (
          <>
            <div className="accordion-body pb-4">
              <Row>
                <Col
                  xs={12}
                  md={12}
                  lg={12}
                  className="commTopButtonRightLeftPadding"
                >
                  <p className="fs-5 fw-medium ms-2 pt-4">
                    Road Transport Details
                  </p>
                  <hr className="mx-2" />
                </Col>

                {/* <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Truck No"
                    name="truckNo"
                    id="truckNo"
                    value={getShipment?.road?.truckNo}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col> */}

                {/* <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Transporter/Courier"
                    name="transporterCourier"
                    id="transporterCourier"
                    value={getShipment?.road?.transporterCourier}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col> */}

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Date of Dispatch"
                    name="dateOfDispatch"
                    id="dateOfDispatch"
                    value={getShipment?.road?.dateOfDispatch}
                    // onChange={handleRadioChange}
                    type="date"
                    disabled={true}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="LR No"
                    name="lrNo"
                    id="lrNo"
                    value={getShipment?.road?.lrNo}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="LR Date"
                    name="lrDate"
                    id="lrDate"
                    value={getShipment?.road?.lrDate}
                    type="date"
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Expected Delivery Date"
                    name="expectedDeliveryDate"
                    id="expectedDeliveryDate"
                    value={getShipment?.road?.expectedDeliveryDate}
                    // onChange={handleRadioChange}
                    type="date"
                    disabled={true}
                  />
                </Col>

                {/* <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="EWaybill No"
                    name="ewaybillNo"
                    id="ewaybillNo"
                    value={getShipment?.road?.ewaybillNo}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col> */}

                {/* <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="E Waybill Value"
                    name="eWaybillValue"
                    id="eWaybillValue"
                    value={getShipment?.road?.eWaybillValue}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col> */}
                

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Challan No"
                    name="challanNo"
                    id="challanNo"
                    value={getShipment?.road?.challanNo}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Challan Date"
                    name="challanDate"
                    id="challanDate"
                    type="date"
                    value={getShipment?.road?.challanDate}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="No. of Packages"
                    name="noOfPackages"
                    id="noOfPackages"
                    value={getShipment?.road?.noOfPackages}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col>

                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Weight of Consignment"
                    name="weightOfConsignment"
                    id="weightOfConsignment"
                    value={getShipment?.road?.weightOfConsignment}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Place of Loading"
                    name="placeOfLoading"
                    id="placeOfLoading"
                    value={getShipment?.road?.placeOfLoading}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Place of Delivery"
                    name="placeOfDelivery"
                    id="placeOfDelivery"
                    value={getShipment?.road?.placeOfDelivery}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Mode of Packing"
                    name="modeOfPacking"
                    id="modeOfPacking"
                    value={getShipment?.road?.modeOfPacking}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Driver Name"
                    name="driverName"
                    id="driverName"
                    value={getShipment?.road?.driverName}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col>
                <Col
                  xs={12}
                  md={4}
                  lg={3}
                  className="commTopButtonRightLeftPadding"
                >
                  <InputField
                    className="inputBox"
                    label="Driver Number"
                    name="driverNumber"
                    id="driverNumber"
                    value={getShipment?.road?.driverNumber}
                    // onChange={handleRadioChange}
                    disabled={true}
                  />
                </Col>
                <Col xs={12} md={4} lg={3} className="commLeftRightPadding">
                  <ComboboxField
                    label="Trip Details"
                    placeholder="Select Trip Type"
                    data={tripType}
                    id="tripTypes"
                    iconClassName="dropdownIcon"
                    name="tripTypes"
                    code="tripTypesCode"
                    description="tripTypesDesc"
                    required={true}
                    getvalue={setDropdownData}
                    setValue={getShipment?.road?.tripTypes || ""}
                    disabled={true}
                  />
                </Col>
                {getTripType === "One Way Trip" && (
                  <>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        type="date"
                        label="Trip Start Date"
                        name="tripstartDate"
                        id="tripstartDate"
                        // value={getTripType?.formInputs?.tripstartDate || ""}
                        value={getTripTypeData?.tripstartDate || ""}
                        onChange={TripTypeonInputChange}
                        disabled={true}
                        required={true}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="From Location"
                        name="fromLocation"
                        id="fromLocation"
                        // value={formInputs?.fromLocation || ""}
                        value={getTripTypeData?.fromLocation || ""}
                        // onChange={TripTypeonInputChange}
                        disabled={true}
                        required={true}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="To Location"
                        name="toLocation"
                        id="toLocation"
                        value={getTripTypeData?.toLocation || ""}
                        onChange={TripTypeonInputChange}
                        disabled={true}
                        required={true}
                      />
                    </Col>
                  </>
                )}
                {getTripType === "Two Way Trip" && (
                  <>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        type="date"
                        label="Trip Start Date"
                        name="tripstartDate2"
                        id="tripstartDate2"
                        value={getTripTypeData?.tripstartDate2 || ""}

                        // disabled={true}
                        required={true}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="From Location"
                        name="fromLocation2"
                        id="fromLocation2"
                        value={getTripTypeData?.fromLocation2 || ""}

                        // disabled={true}
                        required={true}
                      />
                    </Col>
                    <Col
                      xs={12}
                      md={6}
                      lg={3}
                      className="commTopButtonRightLeftPadding"
                    >
                      <InputField
                        className="inputBox"
                        label="To Location"
                        name="toLocation2"
                        id="toLocation2"
                        value={getTripTypeData?.toLocation2 || ""}
                        // disabled={true}
                        required={true}
                      />
                    </Col>
                  </>
                )}
                {getTripType === "Round Trip" && (
                  <>
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                              <i
                                className={`bi ${isCardVisible10
                                  ? "bi-chevron-right"
                                  : "bi-chevron-down"
                                  }`}
                                onClick={toggleCardVisibility10}
                              ></i>
                            </Col>
                            <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                              <span className="iconLogo">TD</span>
                            </Col>
                            <Col xs={4} md={8} lg={4}>
                              <span className="headerTitle">Trip Details</span>
                              <span className="subHeaderTitle">
                                Round Trip Details
                              </span>
                            </Col>
                            <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                              <Col xs={4} md={2} lg={2} className="">
                                <button className="btnTable" onClick={addPOItemRow1}>
                                  <i className="bi bi-plus-lg d-lg-inline d-none"></i> Add
                                </button>
                              </Col>
                            </Col>
                          </Row>
                        </h2>
                        <div
                          // id="acc"
                          className={`accordion-collapse collapse show ${isCardVisible10 ? "visible" : ""
                            }`}
                        // aria-labelledby="headingOne"
                        // data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            {" "}
                            {/* dynamicDropdown */}
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <DataTable
                                  title=""
                                  columns={SchedulePOLineItemInitialCol1}
                                  data={getTripTypeData}
                                  paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                                  pagination
                                  selectableRows
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </Row>
            </div>
          </>
        );
      default:
        return null;
    }
  };

  const [HeaderTextModel, setHeaderTextModel] = useState(false);

  /* Header text selected data */
  const [getHeaderTextSelectedData, setHeaderTextSelectedData] = useState([]);
  const handleHeaderTextSelectedData = (data) => {
    setHeaderTextSelectedData(data);
  };

  useEffect(() => {
    const getTotal = getHeaderTextSelectedData.reduce(
      (accumulator, currentValue) =>
        accumulator + Number(currentValue?.documentText || 0),
      0
    );
    setOtherChargesValue(getTotal);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getHeaderTextSelectedData]);
  const hideHeaderTextModel = () => {
    setHeaderTextModel(false);
  };
  const handleInputChange1 = (local_id, event, fieldName) => {
    const { value } = event.target;

    setPOLineItemsData((prevRows) =>
      prevRows.map((row) => {
        if (row.local_id === local_id) {
          const updatedRow = { ...row, [fieldName]: value };
          const quantity = parseFloat(updatedRow.purchaseQuantity) || 0;
          const unitPrice = parseFloat(updatedRow.orderPriceUnit) || 0;
          updatedRow.itemValue = (quantity * unitPrice).toFixed(2);
          return updatedRow;
        }
        return row;
      })
    );
  };

  // SAVE
  const handleSave = async () => {

    if (transportID !== "") {
      let obj = {
        documentNumber: transportID,
      };
      // setDisabled(true);
      await logistics.getLogisticsTransportDatails(obj).then((item) => {
        if (item?.status === 200) {
          modalData.successMsg = item?.message;
          setFormInputs(item?.data[0])
          setPOLineItemsData(item?.data[0]?.items)


          const tripType = item?.data[0]?.road?.tripTypes;
          setTripType(tripType)
          console.log(">>tripType", tripType)
          if (tripType === "One Way Trip") {
            setTripTypeData(item?.data[0]?.oneWayTrip);
          } else if (tripType === "Two Way Trip") {
            setTripTypeData(item?.data[0]?.twoWayTrip);
          } else if (tripType === "Round Trip") {
            setTripTypeData(item?.data[0]?.tripitems)
          }
          let finalData = { ...formInputs };

          // Conditionally add trip type data
          if (formInputs.tripTypes === "One Way Trip") {
            finalData.tripTypes = {
              ...formInputs.tripTypes,
              oneWayTrip: getTripType
            };
          }

          // pricing Summay & Other charges Data
          setOtherChargesValue(item?.data[0]?.pricingSummary?.getOtherChargesValue)
          setSubTotalValue(item?.data[0]?.pricingSummary?.subTotalValue)
          setGrossValue(item?.data[0]?.pricingSummary?.grossTotalValue)
          setProjectDetails(item?.data[0]?.loactionDetails && item?.data[0]?.loactionDetails);
          setOtherCharges(item?.data[0]?.othersCharge);
          setInvoiceData(item?.data[0]?.invoiceData)

          // Transport Mode Data
          const shipmentData = item?.data[0];
          const detectedModes = ['road', 'air', 'courier', 'ship'].filter(
            mode => shipmentData?.[mode]
          );
          setAvailableShipments(detectedModes);

          setShipment(prev => ({
            ...prev,
            ...(shipmentData?.road && { road: shipmentData.road }),
            // ...(shipmentData?.air && { air: shipmentData.air }),
            // ...(shipmentData?.courier && { courier: shipmentData.courier }),
            // ...(shipmentData?.ship && { ship: shipmentData.ship }),
          }));
          settransportRequest(item?.data[0]?.transportrequestDetails)

          const fetchedData = item?.data[0]; // Fetch data from the response

          // Set customer details for Sender/Consignor
          setCustomerDetails({
            customerName: fetchedData?.senderCustomerName || "",
            address: fetchedData?.senderAddress || "",
            address2: fetchedData?.senderAddress2 || "",
            state: fetchedData?.senderState || "",
            cityPostalCode: fetchedData?.senderCityPostalCode || "",
            otherCustomerContactName: fetchedData?.senderContactName || "",
            otherCustomerContactNumber: fetchedData?.senderContactNumber || "",
          });

          // Check if 'Other Customer' block is needed based on sender data
          const senderOtherBlockDataAvailable = Boolean(
            fetchedData?.senderContactName || fetchedData?.senderContactNumber


          );
          setSenderOthersCustomer(senderOtherBlockDataAvailable);

          // consignee receiver
          setReciverCustomerDetails({
            customerName: fetchedData?.reciverCustomerName || "",
            address: fetchedData?.reciverAddress || "",
            address2: fetchedData?.reciverAddress2 || "",
            state: fetchedData?.reciverState || "",
            cityPostalCode: fetchedData?.reciverCityPostalCode || "",
            otherCustomerContactName: fetchedData?.otherReciverContactName || "",
            otherCustomerContactNumber: fetchedData?.otherReciverContactNumber || "",
            otherReciverCustomerContactName: fetchedData?.otherReciverContactName || "",
            otherReciverContactNumber: fetchedData?.otherReciverContactNumber || "",
          });

          // Check if 'Other Customer' block is needed for Receiver
          const receiverOtherBlockDataAvailable = Boolean(
            fetchedData?.otherReciverContactName || fetchedData?.otherReciverContactNumber
          );
          setReciverOthersCustomer(receiverOtherBlockDataAvailable);

        } else {
          // toast.error(item?.message || "Please try again !!", {
          //   duration: 4000,
          //   position: "top-right",
          // });
        }
      });
    } else {
      navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_LIST);

    }
  };

  useEffect(() => {
    handleSave()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleUpdate = async () => {
    
      const obj = { ...getupdateLogisticsTransport };
      // const obj = {
      //   ...gettransportRequest,
      //   customerDetails: formInputs?.senderAddress?.customerDetails,
      //   subTotalValue: formInputs?.pricingSummary?.subTotalValue,
      //   getOtherChargesValue: formInputs?.pricingSummary?.getOtherChargesValue,
      //   grossTotalValue: formInputs?.pricingSummary?.grossTotalValue,
      //   tripTypes: formInputs?.oneWayTrip?.tripTypes,
      //   tripstartDate: formInputs?.oneWayTrip?.tripstartDate,
      //   fromLocation: formInputs?.oneWayTrip?.fromLocation,
      //   toLocation: formInputs?.oneWayTrip?.toLocation,
      //   tripstartDate2: formInputs?.twoWayTrip?.tripstartDate2,
      //   fromLocation2: formInputs?.twoWayTrip?.fromLocation2,
      //   toLocation2: formInputs?.twoWayTrip?.toLocation2,
      // };
  
      // console.log("obj", obj);
      await logistics.updateLogisticsTransport(obj).then((item) => {
        if (item?.status === 200) {
          // toast.success(item?.message || "Updated successfully", {
          //   duration: 2000,
          //   position: "top-right",
          // });
          navigate(LogisticsConstants.LOGISTICS_TRANSPORT_REQUEST_LIST);
        } else {
          // toast.error(item?.message || "Please try again !!", {
          //   duration: 4000,
          //   position: "top-right",
          // });
        }
      });
    }; 
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };


  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const headerTextHideModal = () => {
    setViewHeaderText(false);
  };

  //price Schedule
  let POLineItemInitialData = [
    {
      local_id: 1,
      materialCode: "",
      materialDescription: "",
      materialGroup: "",
      purchaseQuantity: "",
      orderUnitOfMeasure: "",
      itemValue: "",
      orderPriceUnit: "",
      deliveryDate: "",
      plant: "",
      storageLocn: "",

    },
  ];
  // let POLineItemInitialData1 = [
  //   {
  //     local_id: 1,
  //     tripStartedDate1: "",
  //     toLocation1: "",
  //     fromLocation1: "",
  //     tripKMS: "",
  //   },
  // ];
  const [getPOLineItemsData, setPOLineItemsData] = useState(
    POLineItemInitialData
  );
  

  const removePOItemRow = (local_id) => {
    setPOLineItemsData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id)
    );
  };
  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;

    setPOLineItemsData((prevRows) =>
      prevRows.map((row) =>
        row.local_id === local_id ? { ...row, [name]: value } : row
      )
    );
    // getTotalCount()
  };
  const addPOItemRow1 = () => {
    // setPOLineItemsData1((prevRows) => {
    //   POLineItemInitialData1[0].local_id = prevRows.length + 1;
    //   POLineItemInitialData1[0].purchasingReqDocumentItemNr =
    //     prevRows.length + 1; // make it to 3 digit 001, 002
    //   return [...prevRows, ...POLineItemInitialData1];
    // });
   
  };
  // const handleInputChange2 = (local_id, event, type, vat) => {
  //   const { name, value } = event.target;

  //   // setPOLineItemsData1((prevRows) =>
  //   //   prevRows.map((row) =>
  //   //     row.local_id === local_id ? { ...row, [name]: value } : row
  //   //   )
  //   // );
    // getTotalCount()
  // };


  const [/*getTitle*/, setTitle] = useState([]);
  const [/*getcontactPosition*/, setcontactPosition] = useState([]);
  const [/*getState*/, setState] = useState([]);
  const [/*getCountry*/, setCountry] = useState([]);
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  // const [nextId, setNextId] = useState(1); // Start IDs from 1
  const [/*getdocumentType*/, setdocumentType] = useState([]);

  const getMasterData = async () => {
    let obj = {
      codeType: "title",
    };
    await ItemService.getMasterDataSelf(obj).then((item) => {
      // console.log(">> item! title", item);
      if (item?.status === 200) {
        setTitle(item?.data);
      } else {
        setTitle([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj1 = {
      codeType: "documentType",
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setdocumentType(item?.data);
      } else {
        setdocumentType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj2 = {
      codeType: "jobtitle",
    };
    await ItemService.getMasterDataSelf(obj2).then((item) => {
      // console.log(">> item!", item);
      if (item?.status === 200) {
        setcontactPosition(item?.data);
      } else {
        setcontactPosition([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });

    let obj3 = {
      codeType: "country",
    };
    await ItemService.getMasterDataSelf(obj3).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setCountry(item?.data);
      } else {
        setCountry([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };
  // Onselect of Country state will load


  useEffect(() => {
    // console.log(">>Check getDropdownData Data", getDropdownData);
    if (getDropdownData?.codeType === "country") {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
      getStateData(getDropdownData?.code);
    } else {
      setFormInputs((formInputs) => ({
        ...formInputs,
        [getDropdownData?.textField]: getDropdownData?.name,
        [getDropdownData?.textCode]: getDropdownData?.code,
        [getDropdownData?.textDesc]: getDropdownData?.description,
      }));
    }

  }, [getDropdownData]);

  useEffect(() => {
    // dispatch(getSupplierCategorySelection()); // getSupplierCategorySelection store
    getMasterData();
  }, [dispatch]);


  // Onselect of Country state will load
  const getStateData = async (code) => {
    let obj1 = {
      codeType: "region",
      code: code,
    };
    await ItemService.getMasterDataSelf(obj1).then((item) => {
      // console.log('>> item!',item);
      if (item?.status === 200) {
        setState(item?.data);
      } else {
        setState([]);
        console.log(">> Error: Loading getMasterDataSelf");
      }
    });
  };

  const newProject = {
    projectCode: 1,
    projectCodeDesc: "PROJECT_1",
    projectName: "",
    projectAddress: "",
    projectAddress2: "",
    projectCity: "",
    projectCountry: "IN - India",
    projectState: "IN - Karanataka",
    projectCityPostalCode: "",
    getProjectContactPerson: [
      {
        id: Date.now(), // Unique ID for the first contact person
        projectContactPosition: "",
        projectContactTitle: "",
        projectContactName: "",
        projectContactNumber: "",
        projectContactEmail: "",
      },
    ],
    getProjectCertifications: [
      {
        id: Date.now(),
        name: "Document 1",
        documentType: "",
        certificateCode: "29AADCN1012B1Z6",
        stageDocument: "",
      },
    ],
    getLocations: [],
  };
  const [/*getRouteDetails*/, setRouteDetails] = useState([]);

  const [getProjectDetails, setProjectDetails] = useState([newProject]);



  // end 1

  useEffect(() => {
    if (formInputs?.routeNumber) {
      const route1TableData = [
        {
          slNo: 1,
          routeNumber: 1,
          routeDescription: "Yalahanka",
          tollNumber: 750,
          createdAt: "2023-03-22T13:11:59.098Z",
          tollRates: 25,
          noEntryTimeFromAm: "8:00 AM",
          noEntryTimeToAm: "11:00 AM",
          noEntryTimeFromPm: "3:30 PM",
          noEntryTimeToPm: "8:00 PM",
        },
      ];
      const route2TableData = [
        {
          slNo: 1,
          routeNumber: 2,
          routeDescription: "Melkote	",
          tollNumber: 180,
          createdAt: "2023-03-22T13:11:59.098Z",
          tollRates: 6,
          noEntryTimeFromAm: "8:00 AM",
          noEntryTimeToAm: "11:00 AM",
          noEntryTimeFromPm: "3:30 PM",
          noEntryTimeToPm: "8:00 PM",
        },
        {
          slNo: 2,
          routeNumber: 2,
          routeDescription: "Doddabalapura",
          tollNumber: 180,
          createdAt: "2023-03-22T13:11:59.098Z",

          tollRates: 6,
          noEntryTimeFromAm: "8:00 AM",
          noEntryTimeToAm: "11:00 AM",
          noEntryTimeFromPm: "3:30 PM",
          noEntryTimeToPm: "8:00 PM",
        },
        {
          slNo: 3,
          routeNumber: 2,
          routeDescription: "Doddabalapura	",
          tollNumber: 360,
          createdAt: "2023-03-22T13:11:59.098Z",

          tollRates: 12,
          noEntryTimeFromAm: "8:00 AM",
          noEntryTimeToAm: "11:00 AM",
          noEntryTimeFromPm: "3:30 PM",
          noEntryTimeToPm: "8:00 PM",
        },
        {
          slNo: 4,
          routeNumber: 2,
          routeDescription: "Budigere",
          tollNumber: 395,
          createdAt: "2023-03-22T13:11:59.098Z",

          tollRates: 13,
          noEntryTimeFromAm: "8:00 AM",
          noEntryTimeToAm: "11:00 AM",
          noEntryTimeFromPm: "3:30 PM",
          noEntryTimeToPm: "8:00 PM",
        },
      ];
      const route3TableData = [
        {
          slNo: 1,
          routeNumber: 3,
          routeDescription: "Free zone",
          tollNumber: 0,

          createdAt: "2023-03-22T13:11:59.098Z",
          tollRates: 0,
          noEntryTimeFromAm: "00:00AM",
          noEntryTimeToAm: "00:00AM",
          noEntryTimeFromPm: "00:00PM",
          noEntryTimeToPm: "00:00PM",
        },
      ];

      const newRouteDetails =
        formInputs?.routeNumber === "1"
          ? route1TableData
          : formInputs?.routeNumber === "2"
            ? route2TableData
            : formInputs?.routeNumber === "3"
              ? route3TableData
              : "";

      setRouteDetails((prevRouteDetails) =>
        prevRouteDetails !== newRouteDetails
          ? newRouteDetails
          : prevRouteDetails
      );
    }
  }, [formInputs?.routeNumber]);

  const othersOnInputChange = (e) => {
    const { name, value } = e.target;

    if (name === "customerName") {
      setSenderOthersCustomer(value.trim() !== ""); // 
    }
    setCustomerDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const othersRecevierOnInputChange = (e) => {
    const { name, value } = e.target;
    setReciverCustomerDetails((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [editMode, setEditMode] = useState(true);
  
  const TrasnportUpdate = () => {
    setEditMode(false);
  };
  const cancelUpdate = () => {
    setEditMode(true);
  };




  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide quoation">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">
              Details Transport Request for
              <span className="bg-table-status bg-table-documentNumber-status headerStatusDetailedPage">
                {formInputs?.transportRequestNr}
              </span>

            </h2>
            <p className="subText">Fill Transport Request Details</p>
            <hr />
            <Row className="mb-4">
              {/* edit button */}
              {editMode && (
                <Col
                  xs={6}
                  md={{ span: 2, offset: 10 }}
                  lg={{ span: 2, offset: 10 }}
                  className="text-left"
                >
                  {/* {hasAccess(
                    userRole,
                    "buttons",
                    "customer_details_edit",
                    pageConfigInfo
                  ) && ( */}
                    <Col xs={6} md={2} lg={2} className="text-left">
                      <button className="btnInfo" onClick={TrasnportUpdate}>
                        Edit
                      </button>
                    </Col>
                  {/* )} */}
                </Col>
              )}
              {!editMode && (
                <Col
                  xs={6}
                  md={{ span: 2, offset: 8 }}
                  lg={{ span: 2, offset: 8 }}
                  className="text-left "
                  onClick={handleUpdate}
                >
                  <button className="btnInfo">Update</button>
                </Col>
              )}
              {!editMode && (
                <Col xs={6} md={2} lg={2} className="text-left">
                  <button
                    className="btnInfo btn-danger"
                    onClick={cancelUpdate}
                  >
                    Cancel
                  </button>
                </Col>
              )}
            </Row>


            {/*Document Header Details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible8 ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility8}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">
                        {" "}
                        Transport Request Details
                      </span>
                      <span className="subHeaderTitle">
                        Transport Request Details
                      </span>
                    </Col>

                    <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transport request Date"
                          type="date"
                          name="transportRequestDate"
                          placeholder=""
                          value={gettransportRequest?.transportRequestDate}
                          onChange={transportrequestInputchange}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Company Name"
                          name="department"
                          placeholder=""
                          value={gettransportRequest?.department}
                          onChange={transportrequestInputchange}
                          required={true}
                          disabled={editMode}

                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Transport Group"
                          name="transportGroup"
                          placeholder=""
                          value={gettransportRequest?.transportGroup}
                          onChange={transportrequestInputchange}
                          required={true}
                          disabled={editMode}

                        />
                      </Col>
                      {/* )} */}
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Purchase order Nr/sales Order Nr"
                          name="purchaseOrderNr"
                          placeholder=""
                          value={gettransportRequest?.purchaseOrderNr}
                          onChange={transportrequestInputchange}
                          required={true}
                          disabled={editMode}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Vehicle Nr"
                          name="vehicleNr"
                          placeholder=""
                          value={gettransportRequest?.vehicleNr}
                          onChange={transportrequestInputchange}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <ComboboxField
                          className="inputBox"
                          label="Driver Name"
                          name="driverName1"
                          placeholder=""
                          value={gettransportRequest?.driverName1}
                          onChange={transportrequestInputchange}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="License Nr"
                          name="licenseNr"
                          placeholder=""
                          value={gettransportRequest?.licenseNr}
                          onChange={transportrequestInputchange}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Issuing Date"
                          name="issuingDate"
                          type="date"
                          min={2018}
                          placeholder=""
                          value={gettransportRequest?.issuingDate}
                          onChange={transportrequestInputchange}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={12}
                        md={4}
                        lg={4}
                        className="commTopButtonRightLeftPadding"
                      >
                        <InputField
                          className="inputBox"
                          label="Expiry Date"
                          name="expiryDate"
                          type="date"
                          min={2018}
                          placeholder=""
                          value={gettransportRequest?.expiryDate}
                          onChange={transportrequestInputchange}
                          required={true}
                          disabled={true}
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CS</span>
                    </Col>
                    <Col xs={4} md={8} lg={4}>
                      <span className="headerTitle"> Consignor/Sender</span>
                      <span className="subHeaderTitle">Consignor/Sender</span>
                    </Col>
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        {/* <button
                          className="btnTable"
                          onClick={handleOnAddSender}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button> */}
                      </Col>
                    </Col>

                    {/* <Col xs={2} md={1} lg={1} className="">
                                  <POCollabrationCommonFillter />
                                </Col> */}
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      {senderOthersCustomer && (
                        <Row>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer Name"
                              id="customerName"
                              name="customerName"
                              placeholder=""
                              value={getCustomerDetails?.customerName}
                              onChange={othersOnInputChange}
                              required={true}
                              disabled={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Address"
                              id="address"
                              name="address"
                              value={getCustomerDetails?.address}
                              onChange={othersOnInputChange}
                              disabled={true}
                            // disabled={false}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Pin Code"
                              id="cityPostalCode"
                              name="cityPostalCode"
                              // type="text"
                              value={getCustomerDetails?.cityPostalCode}
                              onChange={othersOnInputChange}
                              disabled={true}
                            // disabled={false}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Name"
                              id="otherCustomerContactName"
                              name="otherCustomerContactName"
                              // type="text"
                              value={
                                getCustomerDetails?.otherCustomerContactName
                              }
                              onChange={othersOnInputChange}
                              disabled={true}
                            // disabled={false}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Number"
                              id="otherCustomerContactNumber"
                              name="otherCustomerContactNumber"
                              // type="text"
                              value={
                                getCustomerDetails?.otherCustomerContactNumber
                              }
                              onChange={othersOnInputChange}
                              disabled={true}
                            // disabled={false}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>
                        </Row>
                      )}
                      {!senderOthersCustomer && (
                        <Row>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Customer Name"
                              placeholder=""
                              data={getCustomer}
                              id="customerName"
                              iconClassName="dropdownIcon"
                              name="customerName"
                              code="customerCode"
                              description="customerNameDesc"
                              setValue={formInputs?.customerName || ""}
                              getvalue={setDropdownData}
                              required={true}
                              // error={validation.country}
                              disabled={true}

                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Customer Address"
                              name="projectAddress"
                              value={[
                                getCustomerDetails?.address,
                                getCustomerDetails?.address2,
                                getCustomerDetails?.address3,
                                getCustomerDetails?.state,
                                getCustomerDetails?.cityPostalCode,
                              ]
                                .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
                                .join(" ")}
                              // onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible1
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility1}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">CR</span>
                    </Col>
                    <Col xs={4} md={8} lg={4}>
                      <span className="headerTitle"> Consignee/Receiver</span>
                      <span className="subHeaderTitle">To Address</span>
                    </Col>
                    <Col xs={12} md={8} lg={8} className="headerButtonAlign">
                      <Col xs={4} md={2} lg={2} className="">
                        {/* <button
                          className="btnTable"
                          onClick={hanleOnAddReceiver}
                        >
                          <i className="bi bi-plus-lg"></i> Add
                        </button> */}
                      </Col>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible1 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      {reciverOthersCustomer && (
                        <Row>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Customer Name"
                              id="customerName"
                              name="customerName"
                              placeholder=""
                              value={getReciverCustomerDetails?.customerName || ""}

                              onChange={othersRecevierOnInputChange}
                              disabled={true}
                              required={true}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Address"
                              id="address"
                              name="address"
                              value={getReciverCustomerDetails?.address || ""}
                              onChange={othersRecevierOnInputChange}
                              disabled={true}
                            // disabled={false}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Pin Code"
                              id="cityPostalCode"
                              name="cityPostalCode"
                              // type="text"
                              value={
                                getReciverCustomerDetails?.cityPostalCode || ""
                              }
                              onChange={othersRecevierOnInputChange}
                              disabled={true}
                            // disabled={false}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Name"
                              id="otherReciverCustomerContactName"
                              name="otherReciverCustomerContactName"
                              // type="text"
                              value={
                                getReciverCustomerDetails?.otherReciverCustomerContactName || ""
                              }
                              onChange={othersRecevierOnInputChange}
                              disabled={true}
                            // disabled={false}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="Contact Number"
                              id="otherReciverContactNumber"
                              name="otherReciverContactNumber"
                              // type="text"
                              value={
                                getReciverCustomerDetails?.otherReciverContactNumber || ""
                              }
                              onChange={othersRecevierOnInputChange}
                              disabled={true}
                            // disabled={false}
                            // error={validation.shippingPostalCode}
                            />
                          </Col>
                        </Row>
                      )}
                      {!reciverOthersCustomer && (
                        <Row>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <ComboboxField
                              label="Customer Name"
                              placeholder=""
                              data={getCustomer}
                              id="reciverCustomerName"
                              iconClassName="dropdownIcon"
                              name="reciverCustomerName"
                              code="reciverCustomerCode"
                              description="reciverCustomerNameDesc"
                              setValue={formInputs?.reciverCustomerName || ""}
                              getvalue={setDropdownData}
                              required={true}
                              disabled={true}
                            // error={validation.country}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commLeftRightPadding"
                          >
                            <TextAreaField
                              className="inputBox"
                              label="Customer Address"
                              name="projectAddress"
                              value={[
                                getReciverCustomerDetails?.address,
                                getReciverCustomerDetails?.address2,
                                getReciverCustomerDetails?.address3,
                                getReciverCustomerDetails?.state,
                                getReciverCustomerDetails?.cityPostalCode,
                              ]
                                .filter(Boolean) // Removes falsy values (null, undefined, empty strings)
                                .join(" ")}
                              // onChange={onInputChange}
                              disabled={true}
                            />
                          </Col>
                        </Row>
                      )}
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Price Shedule / Line Item */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col
                      xs={1}
                      md={1}
                      lg={1}
                      className="text-left arrowBtn"
                    >
                      <i
                        className={`bi ${isCardVisible4
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility4}
                      ></i>
                    </Col>
                    <Col
                      xs={1}
                      md={1}
                      lg={1}
                      className="text-center logoBtn"
                    >
                      <span className="iconLogo">ID</span>
                    </Col>
                    <Col xs={4} md={8} lg={4}>
                      <span className="headerTitle">Item Details</span>
                      <span className="subHeaderTitle">
                        Price Shedule / Line Item
                      </span>
                    </Col>
                    <Col
                      xs={12}
                      md={8}
                      lg={8}
                      className="headerButtonAlign"
                    >
                    </Col>
                  </Row>
                </h2>
                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible4 ? "visible" : ""
                    }`}
                // aria-labelledby="headingOne"
                // data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    {" "}
                    {/* dynamicDropdown */}
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          title=""
                          columns={SchedulePOLineItemInitialCol}
                          data={getPOLineItemsData}
                          paginationRowsPerPageOptions={
                            Constants.ROW_PER_PAGE
                          }
                          pagination
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* radio buttons */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible5
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">MS</span>
                    </Col>

                    <Col xs={4} md={8} lg={4}>
                      <span className="headerTitle">Mode of Transport</span>
                      <span className="subHeaderTitle">Transport Details</span>
                    </Col>
                    <Col xs={4} md={1} lg={4}></Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible5 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="d-flex fs-5 fw-medium ms-3 my-3">
                          <div className="d-flex align-items-center me-3">
                            <div className="form-check">
                              <input
                                ref={inputRef}
                                className="form-check-input me-2"
                                type="radio"
                                value="road"
                                checked={selectedShipment === "road"}
                                // onChange={handleShipmentChange}
                                disabled={!availableShipments?.includes("road")}

                              />
                              <label
                                className="form-check-label fs-5"
                                htmlFor="shipment1"
                              >
                                Road
                              </label>
                            </div>
                          </div>
                        </div>
                        <div>{renderShipmentDetails()}</div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Project Details*/}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible3
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility3}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">LN</span>
                    </Col>
                    <Col xs={8} md={8} lg={8}>
                      <span className="headerTitle">Location Details </span>
                      <span className="subHeaderTitle">Location Details</span>
                    </Col>
                    <Col xs={4} md={2} lg={2}>
                      <div className="d-flex justify-content-end  p-2 me-3"></div>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${isCardVisible3 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    {getProjectDetails?.map((item, index) => (
                      <div key={index}>
                        <Row>
                          <Col xs={12} className="commTopButtonRightLeftPadding">
                            <h5 className="bg-table-status bg-table-warning-status mt-4">
                              Locations
                            </h5>
                            <GoogleMapComponentFromTo
                              projectIndex={index}
                              // getmapdata={onHandleMapData}
                              passmapdata={item?.getLocations || []}
                              editstatus={true}
                            />
                          </Col>
                        </Row>
                        <hr />
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* gmap block end */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible7
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility7}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OC</span>
                    </Col>

                    <Col xs={5} md={9} lg={9}>
                      <span className="headerTitle">Other Charges</span>
                      <span className="subHeaderTitle">
                        Other Charges Table{" "}
                      </span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      {/* <button className="btnTable" onClick={showsetHeaderText}>
                        <i className="bi bi-plus-lg"></i>
                      </button> */}
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible7 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          // title=""
                          columns={HeaderTextColumns}
                          data={otherCharges}
                          disabled={true}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                          selectableRows
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible6
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility6}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">PS</span>
                    </Col>
                    <Col xs={8} md={4} lg={4}>
                      <span className="headerTitle">Pricing Summary</span>
                      <span className="subHeaderTitle">Pricing Summary </span>
                    </Col>
                    <Col xs={2} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible6 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body p-2">
                    <Row className=" ms-3 ">
                      <Col
                        xs={8}
                        md={4}
                        lg={4}
                        className="d-flex my-2 jsutify-content-center align-items-center"
                      >
                        <p className="fw-medium">
                          SubTotal Pricing Schedule / Line Items
                        </p>
                      </Col>
                      <Col
                        xs={4}
                        md={6}
                        lg={6}
                        className="d-flex my-2 jsutify-content-center align-items-center"
                      >
                        <InputField
                          className="inputBox"
                          name="subTotalValue"
                          placeholder=""
                          value={subTotalValue}
                          disabled={true}
                          onChange={pricingSummaryInputchange}
                        />
                        {/* <p className="ms-4 fw-medium"> AED</p> */}
                      </Col>
                      <Col
                        xs={8}
                        md={4}
                        lg={4}
                        className="d-flex my-2 jsutify-content-center align-items-center "
                      >
                        <p className="fw-medium"> SubTotal Other Charges</p>
                      </Col>
                      <Col
                        xs={4}
                        md={7}
                        lg={7}
                        className="d-flex my-2 jsutify-content-center align-items-center "
                      >
                        <InputField
                          className="inputBox"
                          name="getOtherChargesValue"
                          placeholder=""
                          value={getOtherChargesValue}
                          onChange={otherChargeInputchange}
                          disabled={true}
                        />
                      </Col>
                      <Col
                        xs={8}
                        md={4}
                        lg={4}
                        className="d-flex my-2 jsutify-content-center align-items-center"
                      >
                        <p className="fw-medium">Gross Total</p>
                      </Col>
                      <Col
                        xs={4}
                        md={7}
                        lg={7}
                        className="d-flex jsutify-content-center align-items-center"
                      >
                        <InputField
                          className="inputBox"
                          name="grossTotalValue"
                          placeholder=""
                          value={getGrossValue}
                          disabled={true}
                          onChange={GrossValueInputchange}

                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>
            {/* invoice details */}
            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${isCardVisible2
                          ? "bi-chevron-right"
                          : "bi-chevron-down"
                          }`}
                        onClick={toggleCardVisibility2}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">ID</span>
                    </Col>

                    <Col xs={4} md={8} lg={8}>
                      <span className="headerTitle"> Invoice details</span>
                      <span className="subHeaderTitle">Invoice details</span>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="">
                      <POCollabrationCommonFillter />
                    </Col>
                  </Row>
                </h2>

                <div
                  // id="acc"
                  className={`accordion-collapse collapse show ${isCardVisible2 ? "visible" : ""
                    }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <div className="accordion-body">
                          <Row className="pt-2 pb-4">
                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Invoice Number *"
                                name="vendorInvoiceNo"
                                id="vendorInvoiceNo"
                                value={formInputs?.vendorInvoiceNo}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Invoice Date*"
                                name="vendorInvoiceDate"
                                id="vendorInvoiceDate"
                                type="date"
                                value={formInputs?.vendorInvoiceDate}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Basic Value *"
                                name="vendorBasicValue"
                                placeholder="0.00"
                                id="vendorBasicValue"
                                value={subTotalValue}
                                onChange={onInputChange}
                                disabled={true}

                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Tax Amount"
                                name="vendorTaxValue"
                                placeholder="0.00"
                                id="vendorTaxValue"
                                value={formInputs?.vendorTaxValue}
                                onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>

                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Other Charges"
                                name="vendorOtherChargesValue"
                                placeholder="0.00"
                                id="vendorOtherChargesValue"
                                value={getOtherChargesValue?.toFixed(2)}
                                disabled={true}
                              />
                            </Col>
                            <Col
                              xs={12}
                              md={4}
                              lg={3}
                              className="commTopButtonRightLeftPadding"
                            >
                              <InputField
                                className="inputBox"
                                label="Total Invoice Value "
                                name="vendorTotalInvoiceValue "
                                placeholder="0.00"
                                id="vendorTotalInvoiceValue"
                                value={(
                                  Number(subTotalValue || 0) +
                                  Number(getOtherChargesValue || 0) +
                                  Number(formInputs?.vendorTaxValue || 0) +
                                  Number(formInputs?.vendorFreightValue || 0)
                                ).toFixed(2)}
                                // onChange={onInputChange}
                                disabled={true}
                              />
                            </Col>
                          </Row>
                          <hr className="mx-4 mb-3" />
                          <Row className="commLeftRightPadding">
                            <Col md={{ span: 3, offset: 9 }}>
                              {/* <button
                                className="btn w-full"
                                onClick={addInvoiceDocument}
                              >
                                Add Document
                              </button> */}
                            </Col>
                          </Row>

                          <div className="d-flex-column justify-content-center">
                            <Row>
                              <Col xs={6} md={4} lg={4}>
                                <p className="fs-6 fw-medium d-flex justify-content-center w-25">
                                  File
                                </p>
                              </Col>
                              {/* <Col xs={5} md={4} lg={4}>
                                <p className="fs-6 fw-medium d-flex justify-content-center w-20">
                                  View Files
                                </p>
                              </Col> */}
                              {/* <Col xs={1} md={4} lg={4}>
                                <p className="fs-6 fw-medium d-flex justify-content-center w-25">
                                  Action
                                </p>
                              </Col> */}
                            </Row>
                            {invoiceData?.map((doc, index) => (
                              <Row key={index}>
                                <Col xs={12} md={12} lg={12}>
                                  <hr className="mx-4 my-0 text-color-black" />
                                </Col>

                                <Col
                                  xs={5}
                                  md={4}
                                  lg={4}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {(doc.purchaseOrderFileAttachment && (

                                    <img
                                      src="assets/img/newIcons/attached-file.png"
                                      className="mt-1 attachmentIcon"
                                      alt="attachments"
                                      onClick={() =>
                                        handleViewFile(
                                          doc.purchaseOrderFileAttachment
                                        )
                                      }
                                    />
                                  )) ||
                                    "--"}

                                </Col>
                              </Row>
                            ))}
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div>

            {/* Invoice Bank Details */}

          </div>
        </Col>
      </Row>

      {/* Header Text */}
      <HeaderText
        index={0}
        headername="Add Other Charges"
        show={HeaderTextModel}
        onHide={hideHeaderTextModel}
        hedertextdata={handleHeaderTextSelectedData}
        showcurrentdata={getHeaderTextSelectedData}
        masterdata="OtherChargesID"
        type="Number"
      />

      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.POCOLLABRATION_PURCHASE_ORDER_DETAIL_PAGE}
      />

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />

      {/* Header Text  */}
      <CommonItemLevelDatatableModal
        show={getViewHeaderText}
        onHide={() => headerTextHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
    </main>
  );
};

export default TransportRequestDetails;
